// Function checks if href leads to an external site, basing on
// wheather or not provided href starts with https://, http:// or //.
export default function isExternalLink(href: string): boolean {
  return /^(https?:)?\/\//.test(href)
}
